import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
  OnDestroy
} from "@angular/core";
import { IMostAffectedSate } from "./models/most-affected-states";
import { MostAffectedStateService } from "./services/widget-most-affected-states.service";
import * as HSET from "./settings";
import { GenericUtils } from "./../../../utilities/generic-utils";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ActivatedRoute, Params } from "@angular/router";
import { CommonService } from "../../../../shared/services";

@Component({
  selector: "app-widget-most-affected-states",
  templateUrl: "./widget-most-affected-states.component.html",
  styleUrls: ["./widget-most-affected-states.component.scss"],
  providers: [MostAffectedStateService]
})
export class WidgetMostAffectedStatesComponent implements OnInit, OnChanges, OnDestroy {
  @Input() TITLE: string;
  @Input() HEADINGS: string[] = [];
  @Input() FILTERS: object = {};
  @Input() OPTIOPNS: object;
  errorMessage = "";
  data = null;
  mockData = null;
  private unsubscribe: Subject<void> = new Subject();
  constructor(
    private mostAffectedService: MostAffectedStateService,
    private utils: GenericUtils,
    private commonService: CommonService,
    private activateRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    const intiFilter = JSON.parse(JSON.stringify(this.FILTERS))
    this.activateRoute.queryParams.pipe(takeUntil(this.unsubscribe)).subscribe((params: Params) => {
      if (Object.keys(params).length) {
        this.FILTERS = this.commonService.getFiltersParams(params, this.FILTERS);
        this.getMostAffectedStates();
      } else {
        this.FILTERS=JSON.parse(JSON.stringify(intiFilter));
        this.getMostAffectedStates();
      }
    })
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      JSON.stringify(changes.FILTERS.currentValue) !==
      JSON.stringify(changes.FILTERS.previousValue) &&
      !changes.FILTERS.firstChange
    ) {
     
    }
  }

  getMostAffectedStates() {
    this.data = null;
    this.mockData = null;
    this.errorMessage = "";
    const query = JSON.parse(JSON.stringify(this.FILTERS));
    query.limit = "7";
    this.mostAffectedService
      .getMostAffectedStates(this.OPTIOPNS, query)
      .pipe(takeUntil(this.unsubscribe)).subscribe(
        response => {
          if (response.data.length) {
            this.data = response.data;
            this.data.map(customer => {
              customer.value = this.utils.amountIndianUnit(customer.value);
              return customer;
            });
          } else {
            this.errorMessage = "ERROR_MSG.NO_DATA";
            this.mockData = HSET.data;
            this.HEADINGS = HSET.displayedColumns1;
          }
        },
        error => {
          this.errorMessage = "ERROR_MSG.SYSTEM_ERROR";
          this.mockData = HSET.data;
          this.HEADINGS = HSET.displayedColumns1;
        }
      );
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
